export default "__VITE_ASSET__Bdp$2oU3__"